<template>
    <div class="page" data-page="adminTest">
       <div class="container">

           {{ $store.state.settings.siteName }}

       </div>
    </div>
</template>

<script>
    export default {
        data(){
            return{
            }
        },
        mounted(){
            console.log('Settings: ', this.$store.state.settings)
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/Admin/Test.vue